var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "fixBottom", staticClass: "popup px-16 py-24 p-md-24 p-lg-56" },
    [
      _c("div", {
        staticClass: "close",
        on: {
          click: function($event) {
            return _vm.$emit("close")
          }
        }
      }),
      _vm._v(" "),
      _c("h2", { staticClass: "mb-40" }, [
        _vm._v(_vm._s(_vm.translations.add_remark_popup.title))
      ]),
      _vm._v(" "),
      _c("ValidationObserver", {
        ref: "observer",
        attrs: { tag: "div", slim: true },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var invalid = ref.invalid
              return [
                _c("el-input", {
                  staticClass: "mb-40",
                  attrs: {
                    type: "textarea",
                    label: _vm.translations.add_remark_popup.remark,
                    rules: ""
                  },
                  model: {
                    value: _vm.remark,
                    callback: function($$v) {
                      _vm.remark = $$v
                    },
                    expression: "remark"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex mt-40 justify-content-between align-items-center"
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-accent text-white",
                        attrs: {
                          type: "submit",
                          disabled: invalid || _vm.success
                        },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.updateRemark($event)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.translations.add_remark_popup.save))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            return _vm.$emit("close")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.translations.add_remark_popup.cancel))]
                    )
                  ]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }